import React, { useEffect, useState } from "react";
import {getDealStages,createDealStage, updateDealStage, deleteDealStage} from "../api";

export default function DealStages() {

    const [stages, setStages] = useState([]);
    const saveStage = async () => {

    if (!stageName.trim()) return;

    try {

        if(editingId){

await updateDealStage(
  editingId,
  stageName
);

}else{

await createDealStage(stageName);

}

        const res = await getDealStages();

        setStages(res.data);

        setStageName("");
setEditingId(null);
setShowModal(false);

    } catch (err) {

        console.log(err);

    }

};

const removeStage = async (id) => {

    if (!window.confirm("Delete this stage?")) return;

    try {

        await deleteDealStage(id);

        const res = await getDealStages();

        setStages(res.data);

    } catch (err) {

        console.log(err);

    }

};

    const [showModal, setShowModal] = useState(false);
    const [stageName, setStageName] = useState("");
    const [editingId, setEditingId] = useState(null);

    useEffect(() => {
        loadStages();
    }, []);

    async function loadStages() {

        const res = await getDealStages();

        setStages(res.data);

    }

    return (

<div style={{padding:"30px"}}>

    <div
        style={{
            display:"flex",
            justifyContent:"space-between",
            alignItems:"center",
            marginBottom:"20px"
        }}
    >

        <h2>Deal Stages</h2>

        <button
    onClick={() => {
  setEditingId(null);
  setStageName("");
  setShowModal(true);
}}
    style={{
        padding:"8px 16px",
        background:"#28a745",
        color:"#fff",
        border:"none",
        borderRadius:"6px",
        cursor:"pointer"
    }}
>
    + Add Stage
</button>

    </div>

    <table
            border="1"
            cellPadding="10"
            style={{marginTop:20}}
            >

                <thead>

                    <tr>

<th>ID</th>

<th>Stage</th>

<th>Edit</th>

<th>Delete</th>

</tr>

                </thead>

                <tbody>

{

stages.map(stage=>(

<tr key={stage.id}>

<td>{stage.id}</td>

<td>{stage.display_name}</td>

<td>

<button

onClick={()=>{

setEditingId(stage.id);

setStageName(stage.display_name);

setShowModal(true);

}}

style={{

background:"#2563eb",
color:"#fff",
border:"none",
padding:"6px 14px",
borderRadius:6,
cursor:"pointer"

}}

>

Edit

</button>

</td>

<td>

<button

onClick={() => removeStage(stage.id)}

style={{

background:"#dc2626",
color:"#fff",
border:"none",
padding:"6px 14px",
borderRadius:6,
cursor:"pointer"

}}

>

Delete

</button>

</td>

</tr>

))

}

</tbody>

            </table>

{
showModal && (

<div
style={{
position:"fixed",
top:0,
left:0,
width:"100%",
height:"100%",
background:"rgba(0,0,0,.35)",
display:"flex",
justifyContent:"center",
alignItems:"center"
}}
>

<div
style={{
width:"400px",
background:"#fff",
padding:"25px",
borderRadius:"10px"
}}
>

<h3>

{editingId ? "Edit Deal Stage" : "Add Deal Stage"}

</h3>

<input
value={stageName}
onChange={(e)=>setStageName(e.target.value)}
placeholder="Stage Name"
style={{
width:"100%",
padding:"10px",
marginTop:"15px",
marginBottom:"20px"
}}
/>

<div
style={{
display:"flex",
justifyContent:"flex-end",
gap:"10px"
}}
>

<button

onClick={()=>{

setShowModal(false);

setStageName("");

setEditingId(null);

}}

>
Cancel
</button>

<button
onClick={saveStage}
style={{
background:"#28a745",
color:"#fff",
border:"none",
padding:"10px 18px",
borderRadius:"5px",
cursor:"pointer"
}}
>
Save
</button>

</div>

</div>

</div>

)

}

</div>


    );

}